export const PLUGINS = 'plugins';
export const THEMES = 'color_schemes';
export const TEMPLATES = 'templates';



/** WEBPACK FOOTER **
 ** ./client/constants/PackageTypes.ts
 **/